module.exports = __webpack_public_path__ + "assets/img/img194.72ed33c6.png";